module.exports = "/_next/static/images/prefooter-contact@2x_f8a0d5aae936e45abd0f48258bbabd68.webp";